import { ROUTES } from '#/config/routes';

/**
 * 工單轉倉建立頁 deep link：僅預填目標倉 warehouse_id。
 * 不帶 workOrderId／mtr。
 */
export function buildWorkOrderTransferCreateUrl({ warehouseId } = {}) {
  if (!warehouseId) {
    return ROUTES.workOrderTransferCreate;
  }
  const params = new URLSearchParams();
  params.set('warehouse_id', String(warehouseId));
  return `${ROUTES.workOrderTransferCreate}?${params.toString()}`;
}
